import { createSlice } from '@reduxjs/toolkit';
import { completeRemainingTicketReports, downloadTicketReportsList, getTicketReports } from './ticketReportsService';

const initialState = {
    ticketReports: {
        isTicketReportsLoading: null,
        isTicketReportsSuccess: null,
        pageCount: 0,
        ticketReports: [],
        ticketReportsCount: 0,
    },
    ticketReportsFile: {
        isFileDownloading: null,
        fileDownloadedMsg: null,
        isFileDownloadSuccess: null
    },
};

const ticketReportSlice = createSlice({
    name: 'ticketReport',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getTicketReports.pending, (state) => {
            state.ticketReports = {
                ...initialState.ticketReports,
                isTicketReportsLoading: true,
            };
        });

        builder.addCase(getTicketReports.rejected, (state) => {
            state.ticketReports = {
                ...initialState.ticketReports,
                isTicketReportsLoading: false,
                isTicketReportsSuccess: false,
            };
        });

        builder.addCase(getTicketReports.fulfilled, (state, action) => {
            state.ticketReports = {
                ...initialState.ticketReports,
                isTicketReportsLoading: false,
                isTicketReportsSuccess: true,
                pageCount: action.payload.pageCount || 0,
                ticketReports: action.payload.data || [],
                ticketReportsCount: action.payload.count || 0,
            };
        });

        //Download TicketReports
        builder.addCase(downloadTicketReportsList.pending, (state) => {
            state.ticketReportsFile = {
                ...initialState.ticketReportsFile,
                isFileDownloading: true,
            };
        });

        builder.addCase(downloadTicketReportsList.rejected, (state, action) => {
            state.ticketReportsFile = {
                ...initialState.ticketReportsFile,
                isFileDownloading: false,
                fileDownloadedMsg: action.payload.message,
                isFileDownloadSuccess: false
            };
        });

        builder.addCase(downloadTicketReportsList.fulfilled, (state, action) => {
            state.ticketReportsFile = {
                ...initialState.ticketReportsFile,
                isFileDownloading: false,
                fileDownloadedMsg: action.payload.message,
                isFileDownloadSuccess: true
            };
        });
    },
});

export default ticketReportSlice.reducer;
